<div mat-dialog-content style="color: #0F223E" fxLayoutAlign="center center">
  {{message}}
</div>
<div mat-dialog-actions fxLayoutAlign="center center">
  <button mat-button (click)="onNoClick()">No</button>
  <button mat-button [mat-dialog-close]="true">Sí</button>
</div>
